import React, { useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import MainLogo from "../../assets/icons/logo.svg";
import Home from "../../assets/icons/bar-chart-2-normal.svg";
import HomeActive from "../../assets/icons/bar-chart-2.svg";
import Recommendation from "../../assets/icons/chat.svg";
import RecommendationActive from "../../assets/icons/chat-active.svg";
import Invitation from "../../assets/icons/3-layers-normal.svg";
import InvitationActive from "../../assets/icons/3-layers.svg";
import useAuthStore from "../../data/stores/authStore";
import Avatar from "../../assets/icons/Avatar.svg";
import Logout from "../../assets/icons/logout.svg";

const Sidebar = ({ children }) => {
	const [nav, setNav] = useState(false),
		toggleNav = () => {
			setNav(!nav);
		},
		location = useLocation(),
		path = location?.pathname,
		navigate = useNavigate(),
		{ user, logout } = useAuthStore();
	let sidebarList = [
		{
			name: "home",
			url: "/dashboard",
			icon: Home,
			active: HomeActive,
		},
		{
			name: "recommendation",
			url: "/recommendation",
			icon: Recommendation,
			active: RecommendationActive,
		},
	];
	if (user?.privilege === "system owner") {
		sidebarList?.push({
			name: "Invitations",
			url: "/focal-person",
			icon: Invitation,
			active: InvitationActive,
		});
	}
	// if (user?.privilege === "focal person") {
	// 	sidebarList?.push({
	// 		name: "ERP Data",
	// 		url: "/flow",
	// 		icon: Recommendation,
	// 		active: RecommendationActive,
	// 	});
	// }

	const excludedPaths = [
		"/",
		"/invitation",
		"/login",
		"/flow",
		"/request",
		"/forgotpassword",
	];
	return (
		<div className="bg-jiblack">
			{!excludedPaths?.includes(path) && (
				<>
					<button
						onClick={toggleNav}
						className="inline-flex bg-white items-center ml-3 text-sm overflow-visible ">
						<span className="sr-only">Open sidebar</span>
						<AiOutlineMenu color="white" size={20} />
					</button>
					{/* Backdrop for mobile sidebar */}
					{nav && (
						<div
							className={`fixed lg:hidden top-0 left-0 z-40 w-full h-screen bg-white opacity-50`}
							onClick={toggleNav}></div>
					)}
					{/* Sidebar */}
					<aside
						className={`fixed shadow-sm top-0 left-0 z-50 w-64 bg-white h-screen pb-8 transition-transform transform ${
							nav ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
						}`}>
						<div className="min-h-screen relative py-6 noScroll">
							<div className="flex justify-center my-6 w-full">
								<img src={MainLogo} alt="" className="w-5/6 mx-auto" />
							</div>
							<div className="mt-6 space-y-4 w-5/6 mx-auto">
								{sidebarList?.map(it => (
									<div
										key={it?.url}
										onClick={() => {
											navigate(it?.url);
										}}
										className={` h-10 px-4 flex cursor-pointer justify-between items-center w-full rounded-lg ${
											path === it?.url || path?.includes(it?.url)
												? "bg-es-blue-100 text-primary"
												: "bg-transparent text-sec"
										}`}>
										<div className={`flex cursor-pointer gap-2 items-center  `}>
											<div>
												{path === it?.url || path?.includes(it?.url) ? (
													<img src={it?.active} alt="" className="" />
												) : (
													<img src={it?.icon} alt="" className="" />
												)}
											</div>
											<strong className="text-base capitalize font-medium">
												{it?.name}
											</strong>
										</div>
									</div>
								))}
							</div>
							<div className="absolute bottom-10 w-full">
								<div className="flex px-2 pt-4 border-t border-t-[#EAECF0] justify-between items-center">
									<div className="flex items-center gap-3">
										<img src={Avatar} alt="" className="" />
										<div>
											<h5 className="text-sm font-medium text-es-gray-200">
												{user?.user?.organizationName ||
													user?.user?.departmentName}
											</h5>
											<h6 className="text-sm font-normal text-[#667085]">
												{user?.user?.email}
											</h6>
										</div>
									</div>
									<img
										src={Logout}
										alt=""
										className="pb-3 cursor-pointer"
										onClick={logout}
									/>
								</div>
							</div>
						</div>
					</aside>
				</>
			)}

			{/* Main content area */}
			<div className={`${!excludedPaths.includes(path) ? "lg:ml-64" : ""}`}>
				<div>{children}</div>
			</div>
		</div>
	);
};

export default Sidebar;
